import { ApiService } from './api.service'

const BaseUrl = '/handle-param'

export function handleDohBoParam (params = {}) {
  return ApiService.post(`${BaseUrl}`, params).then(resp => resp.data)
}
